export default __webpack_public_path__ + "static/SourceCodePro.normal-8d575ca96dacf6ceebf5619d94ab2c24.ttf";